import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SoundService {
  private readonly isSoundActive = new BehaviorSubject<boolean>(false);
  readonly isSoundActive$: Observable<boolean> = this.isSoundActive.asObservable();

  changeSoundState(): void {
    this.isSoundActive.next(true);
  }
}
